import { render } from "./ConfirmUploadRemovalModal.vue?vue&type=template&id=1ebb8eb7"
import script from "./ConfirmUploadRemovalModal.vue?vue&type=script&lang=js"
export * from "./ConfirmUploadRemovalModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ConfirmUploadRemovalModal.vue"]])

export default __exports__